export const PROFILE = ['profile'] as const

export const NOTIFICATIONS = ['notifications'] as const
